import { Locale } from "./locale.type";

export default {
  apartment: {
    apartment: "Lägenhet",
    apartments: "Lägenheter",
  },
  holding: {
    holding: "Upplåtelse",
    holdings: "Upplåtelser",
  },
  lease: {
    lease: "Hyreskontrakt",
    leases: "Hyreskontrakt",
  },
  sublet: {
    sublet: "Andrahandsupplåtelse",
    sublets: "Andrahandsupplåtelser",
  },
  person: {
    person: "Person",
    persons: "Personer",
  },
  organization: {
    organization: "Organisation",
    organizations: "Organisationer",
  },
  role: {
    role: "Roll",
    roles: "Roller",
  },
  resident: {
    resident: "Boende",
    residents: "Boenden",
  },
  tenant: {
    tenant: "Hyresgäst",
    tenants: "Hyresgäster",
  },
  subtenant: {
    subtenant: "Andrahandshyresgäst",
    subtenants: "Andrahandshyresgäster",
  },
} as Locale;
